export function decimalToPercentage(decimal: number): number {
  return decimal * 100
}

export function percentageToDecimal(percentage: number): number {
  return percentage / 100
}
